export default function JobPenOnlyIco({ fill = "#049F9A", size }) {
  return (
    <svg
      width={size || "23"}
      height={size || "23"}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10280_18616)">
        <path
          d="M7.41442 9.25259L6.93055 15.531C6.91897 15.6927 6.96021 15.8539 7.04912 15.9896L10.2256 12.1608C9.74111 11.6156 9.72637 10.7986 10.1917 10.2368C11.4969 8.77402 13.6643 10.5752 12.4656 12.1233C12.001 12.6806 11.2008 12.8192 10.5754 12.4509L7.39889 16.2798C7.5491 16.3417 7.71594 16.3524 7.87298 16.3099L13.9526 14.6769C14.2288 14.6012 14.4378 14.3751 14.4923 14.094L15.0962 10.96C15.0785 10.96 10.8721 7.45552 10.8563 7.44242L7.88905 8.61297C7.62163 8.71817 7.43732 8.96614 7.41438 9.25275L7.41442 9.25259Z"
          fill={fill}
        />
        <path
          d="M12.1197 11.8373C12.436 11.3999 12.3589 10.7925 11.9435 10.4479C11.5281 10.1033 10.9169 10.1396 10.5455 10.5313C9.71352 11.5981 11.2246 12.8488 12.1197 11.8373Z"
          fill={fill}
        />
        <path
          d="M11.1961 7.13515L15.3346 10.5686C15.6245 10.8091 16.0542 10.7691 16.2947 10.4792L17.4861 9.04313C17.7266 8.75322 17.6866 8.32357 17.3967 8.08305L13.2582 4.64964C12.9683 4.40912 12.5386 4.44912 12.2981 4.73904L11.1067 6.17507C10.8662 6.46498 10.9062 6.89463 11.1961 7.13515Z"
          fill={fill}
        />
        <path
          d="M7.81456 16.205L7.81543 16.2049L10.7541 13.4458L13.8896 12.7988L14.0778 11.0058L10.9993 8.45183L9.65671 9.28701L9.2149 12.1688C8.47001 13.0667 6.99377 15.0031 7.04588 15.5663C7.11104 16.2706 7.11132 16.2705 7.81456 16.205Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_10280_18616">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(12.3125 22.5312) rotate(-140.32)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
